import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/Save";

type Props = {
  addWorkflow: (name: string, isDataAsset: boolean) => void;
  createDataAsset: boolean;
};

export default function WorkflowCreator({addWorkflow, createDataAsset}: Props) {
  const [showWorkflowAdder, setShowWorkflowAdder] = useState(false);
  const [name, setName] = useState("");
  if (!showWorkflowAdder) {
    return (
      <button onClick={() => setShowWorkflowAdder(true)}>
        Add {createDataAsset ? "Data Asset" : "Workflow"}
      </button>
    );
  }

  function workflowAdded() {
    setShowWorkflowAdder(false);
    addWorkflow(name, createDataAsset);
    setName("");
  }

  const label = createDataAsset ? "Data Asset Name" : "Workflow Name";

  return (
    <div>
      <TextField
        label={label}
        value={name}
        onChange={event => setName(event.target.value)}
      />
      <IconButton onClick={workflowAdded} disabled={name.length === 0}>
        <SaveIcon />
      </IconButton>
    </div>
  );
}
